
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories",
      function () {
        return require("private-next-pages/stories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories"])
      });
    }
  